<template>
  <nav>
    <ul class="nav nav-tabs">
      <li v-for="link in links" :key="link" class="nav-item">
        <router-link class="nav-link" :class="{active: activeLink == link}" :to="{name: link}">
          {{ $t('navigation.' + link)}}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  computed: {
    activeLink () {
      return this.$route.meta.activeTab
    },
    links () {
      return this.$store.getters.currentUser && this.$store.getters.currentUser.membership && this.$store.getters.currentUser.membership.valid ?
        ['membership', 'payment', 'profile']
        : ['membership', 'profile']
    }
  }
}
</script>

<style lang="scss" scoped>
  .nav-tabs {
    border-bottom: 2px solid $border-color;
    padding: 0;

    .nav-item {
      // margin-bottom: -1px;
      .nav-link {
        background: none;
        border: none;
      }
      a {
        font-family: $secondary-font-family;
        letter-spacing: 1px;
        font-size: 1rem;
        text-transform: uppercase;

        color: $nav-inactive;
        line-height: 33px;
        padding: 10px 0;
        margin-right: 20px;
        &:hover {
          color: $nav-active;
          //border-color: transparent transparent $gray-4;
        }

        /*&:after {
          content: "";
          display: block;
          width: 0;
          height: 2px;
          background-color: $nav-active;
          transition: width .35s;
          top: -5px;
          position: relative;
        }
        &:hover, &.active {
          &:after {
            width: 100%;
          }
        }*/

      }
      .active {
        color: $nav-active;
        //font-weight: bold;
        //border-color: transparent transparent $primary-btn-bg;
        &:hover {
          //border-color: transparent transparent $primary-btn-bg;
          color: $nav-active;
        }
        &:hover:after {
          width: 100%;
        }
      }
    }
  }
</style>


